import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import classnames from 'classnames';
import React from 'react';
import alertUserOfDeprecatedProps from '../utils/deprecation.js';

var _excluded = ["children", "className", "below", "above", "uppercase"];
var Caption = function Caption(_ref) {
  var children = _ref.children,
    className = _ref.className,
    below = _ref.below,
    above = _ref.above,
    uppercase = _ref.uppercase,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  alertUserOfDeprecatedProps('Caption', otherProps);
  var finalClasses = classnames('C-Caption', {
    '--above': above,
    '--below': below,
    '--uppercase': uppercase
  }, className);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: finalClasses
  }, otherProps), above && /*#__PURE__*/React.createElement("div", {
    className: "C-Caption__content"
  }, above), children, below && /*#__PURE__*/React.createElement("div", {
    className: "C-Caption__content"
  }, below));
};
Caption.displayName = 'Caption';

export { Caption as default };
